import {useResultPageStore} from "../stores/ResultPageStore";
import {EventBus} from "../events/event.bus";
import {EVENT_APP_NAVIGATE} from "../events/app.events";
import {JOB_STATE_DRAFT} from '../const/job.const';
import JobManager from "./JobManager";
import {testIsNotUndefined} from "../../../../../../lib/test-and-assert/test-base";
import TabManager from "./TabManager";
import {EVENT_JOB_COMPLETE, EVENT_JOB_INIT_SUCCESS} from "../events/job.events";
import PreviewManager from "./PreviewManager";
import OutputSelectionManager from "./OutputSelectionManager";
import ThumbnailManager from "./ThumbnailManager";
import {satGlobals} from "../../../../../sat/helper/sat-globals";

class MagicEditorManager {

    listener = false;

    constructor() {
    }

    listen() {
        if (this.listener === true) {
            return;
        }

        this.store = useResultPageStore();

        this.listener = true;

        EventBus.$on(EVENT_JOB_INIT_SUCCESS, (data) => {
            if (satGlobals.getProjectName().toLowerCase() === 'online-convert') {
                window.startAds('image')
            }
            this.openInitialView(data)
        });

        EventBus.$on(EVENT_JOB_COMPLETE, (job) => {
            TabManager.updateOutputTabs(job);
            OutputSelectionManager.selectAll(job);

            let outputs = [];

            job.apiJob.output.forEach((output) => {
                if (PreviewManager.canPreviewMini(JobManager.getExtensionFromOutput(output), output.size)){
                    outputs.push(output);
                }
            })

            if (outputs.length > 0) {
                ThumbnailManager.generateThumbnail(job, outputs);
            }
        });
    }

    openInitialView(job) {
        this.store = useResultPageStore();

        if (PreviewManager.hasFeature(job)) {
            this.openFileList(job.id, false)
            PreviewManager.openInitialFeature(job)
            return;
        }

        // Disabled for testing user reaction
        //if (PreviewManager.canPreview(job.apiJob.conversion[0].target) && job.apiJob.input.length === 1 && this.store.resultPage.isMobile === false) {
        //    this.openFileList(job.id, false)
        //   PreviewManager.openInitialPreview(job)
        //    return;
        //}

        if (this.store.resultPage.isMobile === true) {
            this.openFileList(job.id, false);
            return;
        }

        this.openFileList(job.id);
    }

    openJob(id, previousId = null) {
        this.store = useResultPageStore();

        if (previousId !== null) {
            let previousJob = this.store.getJobById(previousId);
            if (previousJob.state === JOB_STATE_DRAFT) {
                previousJob.settings = JSON.parse(JSON.stringify(this.store.getSettings()));
            }
        }

        EventBus.$emit(EVENT_APP_NAVIGATE, `/${id}`, {})
        //this.store.updateSettings(JSON.parse(JSON.stringify(this.store.getJobById(id).settings)));
    }

    newJob(jobId = null) {

        if (jobId === null) {
            jobId = JobManager.create();
        }

        let tab = TabManager.create();
        tab.type = 'job';
        tab.path = `/${jobId}`;
        tab.name = `Inpainting`;
        tab.icon = 'far fa-image';
        tab.dismissable = false;
        TabManager.createTab(tab);

        this.openJob(jobId);
    }

    initJob(id) {
        this.store = useResultPageStore();

        const fragmentData = qgQueryFragmentHelper.getCurrentFragmentData();
        const jobID = fragmentData?.j;
        if (testIsNotUndefined(jobID)) {
            EventBus.$emit(EVENT_APP_NAVIGATE, `/${id}/welcome`, {})
            JobManager.initFromJobId(id, jobID);
            return;
        }

        this.newJob(id);
        //EventBus.$emit(EVENT_APP_NAVIGATE, `/${id}/welcome`, {})

        //EventBus.$emit(EVENT_APP_NAVIGATE, `/not-found`, {})

        //this.store.updateSettings(JSON.parse(JSON.stringify(this.store.getJobById(id).settings)));
    }

    watchMobile() {
        this.store = useResultPageStore();

        addEventListener("resize", (event) => {
            this.updateMobile();
        });
    }

    updateMobile() {
        let isFullRes = window.matchMedia('(min-width: 1900px)').matches;
        if (isFullRes) {
            this.store.resultPage.isMobile = false;
            this.store.resultPage.isFullRes = true;
        }

        let isMediumRes = window.matchMedia('(max-width: 1899px)').matches;
        if (isMediumRes) {
            this.store.resultPage.isMobile = false;
            this.store.resultPage.isFullRes = false;
        }

        let isMedia = window.matchMedia('(max-width: 2222px)').matches;
        if (isMedia) {
            this.store.resultPage.isMediumRes = true;
        } else {
            this.store.resultPage.isMediumRes = false;
        }

        let isMobile = window.matchMedia('(max-width: 1200px)').matches;
        if (isMobile) {
            this.store.resultPage.isMobile = true;
            this.store.resultPage.isFullRes = false;
        }
    }

    openFileList(id, open = true) {
        let tab = TabManager.create();
        tab.type = 'file_list';
        tab.path = `/${id}/canvas`;
        tab.name = 'Change Me';
        tab.icon = 'far fa-list';
        tab.dismissable = false;
        TabManager.createTab(tab);

        if (open) {
            TabManager.openTab(tab);
        }
    }
}

export default new MagicEditorManager()